export const iconSize = Object.freeze({
    //размеры иконок
    sm: 16,
    md: 24,
    lg: 32,
});